import { render, staticRenderFns } from "./SetCoach.vue?vue&type=template&id=8b0a4a2c&scoped=true"
import script from "./SetCoach.vue?vue&type=script&lang=js"
export * from "./SetCoach.vue?vue&type=script&lang=js"
import style0 from "./SetCoach.vue?vue&type=style&index=0&id=8b0a4a2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0a4a2c",
  null
  
)

export default component.exports